import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { Col, Row } from "react-bootstrap";
import { WizardSteps } from "./WizardSteps";
import { Nextsteps } from "./NextStep";
import warning from "../../assets/icons/warning.png";

export const Last = (props) => {
  const submit = () => {
    alert("You did it! Yay!"); // eslint-disable-line
  };

  const [state, updateState] = useState({
    confirmWorkEligiblility: false,
    confirmValidDocs: false,
    agreeToTOS: false,
    phoneNumber: "",
    onFocusPhoneNumber: false,
    securityCode: "",
    num1: "",
    num2: "",
    num3: "",
    num4: "",
  });

  let num1Input = useRef(null);
  let num2Input = useRef(null);
  let num3Input = useRef(null);
  let num4Input = useRef(null);

  const handleFocus = (e) => e.target.select();

  const handleChange = (e, num) => {
    if (num === 1 && e.target.value.length <= 1) {
      updateState({
        ...state,
        num1: e.target.value,
        securityCode: e.target.value + state.num2 + state.num3 + state.num4,
      });
      if (e.target.value.length === 1) {
        ReactDOM.findDOMNode(num2Input).focus();
      }
    }
    if (num === 2 && e.target.value.length <= 1) {
      updateState({
        ...state,
        num2: e.target.value,
        securityCode: state.num1 + e.target.value + state.num3 + state.num4,
      });
      if (e.target.value.length === 1) {
        ReactDOM.findDOMNode(num3Input).focus();
      } else ReactDOM.findDOMNode(num1Input).focus();
    }
    if (num === 3 && e.target.value.length <= 1) {
      updateState({
        ...state,
        num3: e.target.value,
        securityCode: state.num1 + state.num2 + e.target.value + state.num4,
      });
      if (e.target.value.length === 1) {
        ReactDOM.findDOMNode(num4Input).focus();
      } else ReactDOM.findDOMNode(num2Input).focus();
    }
    if (num === 4 && e.target.value.length <= 1) {
      updateState({
        ...state,
        num4: e.target.value,
        securityCode: state.num1 + state.num2 + state.num3 + e.target.value,
      });
      if (e.target.value.length !== 1) {
        ReactDOM.findDOMNode(num3Input).focus();
      }
    }
  };

  const handleKey = (e, num) => {
    if (num === 1) {
      if (e.keyCode === 39) {
        ReactDOM.findDOMNode(num2Input).focus();
        ReactDOM.findDOMNode(num2Input).select();
      }
      if (e.keyCode === 37) {
        ReactDOM.findDOMNode(num4Input).focus();
        ReactDOM.findDOMNode(num4Input).select();
      }
    }
    if (num === 2) {
      if (e.keyCode === 39) {
        ReactDOM.findDOMNode(num3Input).focus();
        ReactDOM.findDOMNode(num3Input).select();
      }
      if (e.keyCode === 37) {
        ReactDOM.findDOMNode(num1Input).focus();
        ReactDOM.findDOMNode(num1Input).select();
      }
    }
    if (num === 3) {
      if (e.keyCode === 39) {
        ReactDOM.findDOMNode(num4Input).focus();
      }
      if (e.keyCode === 37) {
        ReactDOM.findDOMNode(num2Input).focus();
      }
    }
    if (num === 4) {
      if (e.keyCode === 39) {
        ReactDOM.findDOMNode(num1Input).focus();
      }
      if (e.keyCode === 37) {
        ReactDOM.findDOMNode(num3Input).focus();
      }
    }
  };

  useEffect(() => {
    let {
      confirmWorkEligiblility,
      confirmValidDocs,
      agreeToTOS,
      phoneNumber,
    } = state;
    let TutorInfoObj = props?.TutorInfoObj ? props?.TutorInfoObj : {};
    confirmWorkEligiblility = TutorInfoObj?.step9?.confirmWorkEligiblility
      ? TutorInfoObj?.step9?.confirmWorkEligiblility
      : "";
    confirmValidDocs = TutorInfoObj?.step9?.confirmValidDocs
      ? TutorInfoObj?.step9?.confirmValidDocs
      : "";
    agreeToTOS = TutorInfoObj?.step9?.agreeToTOS
      ? TutorInfoObj?.step9?.agreeToTOS
      : "";
    phoneNumber = TutorInfoObj?.step9?.phoneNumber
      ? TutorInfoObj?.step9?.phoneNumber
      : "";

    updateState((state) => ({
      ...state,
      //confirmWorkEligiblility,
      //confirmValidDocs,
      //agreeToTOS: agreeToTOS,
      phoneNumber,
    }));
    if (props.funcStatus === "loading..." && props.currentStep === 9) {
      submitStep9Info(true);
    }
  }, [props]);

  // step9: {
  //   confirmWorkEligiblility: false,
  //   confirmValidDocs: false,
  //   agreeToTOS: false,
  //   phoneNumber: "617-982-4020",
  // },

  const submitStep9Info = (isCallApi) => {
    const {
      confirmWorkEligiblility,
      confirmValidDocs,
      agreeToTOS,
      phoneNumber,
    } = state;
    const { TutorInfoObj } = props;

    let step9 = {
      confirmWorkEligiblility,
      confirmValidDocs,
      agreeToTOS,
      phoneNumber,
    };
    TutorInfoObj.step9 = step9;
    props.AddTutorInfo(TutorInfoObj);
    return isCallApi ? props.AddTutorInfoStepBeforeCallApi("done") : null;
    // if (phoneNumber) {
    //   TutorInfoObj.step9 = step9;
    //   props.AddTutorInfo(TutorInfoObj);
    //   return true;
    // } else {
    //   return false;
    // }
  };
  let {
    confirmWorkEligiblility,
    confirmValidDocs,
    agreeToTOS,
    phoneNumber,
    onFocusPhoneNumber,
    securityCode,
    num1,
    num2,
    num3,
    num4,
  } = state;
  const { iscompletedForm, validationError } = props;

  let warningError = (
    <img
      src={warning}
      alt="warning"
      width="14px"
      height="14px"
      style={{ marginRight: "6px" }}
    />
  );

  let color, borderColor, backgroundColor;

  if (onFocusPhoneNumber) {
    color = "";
    borderColor = "#2cb46d";
    backgroundColor = "";
  } else if (!phoneNumber && validationError?.data?.phoneNumber) {
    color = "#fa4a4a";
    borderColor = "#fa4a4a";
    backgroundColor = "#fff1f1";
  } else {
    color = "";
    borderColor = "";
    backgroundColor = "";
  }

  return (
    <Row className="m-0">
      <WizardSteps step={9} {...props} nextStep={submit} />
      <Col lg={12} md={12} sm={12} xs={12}>
        <div className="container">
          <Row>
            <Col
              lg={12}
              md={12}
              sm={12}
              xs={12}
              className="subject-mode review_nd_sumbit"
            >
              <p className="step-title">
                Review Askademia policies before submitting application
              </p>
              <p className="step-subtitle">
                By submitting I confirm the following is true:
              </p>

              <div className="checkBoxContainer">
                <label
                  className="container"
                  htmlFor="customCheck91"
                  style={{ paddingTop: "13px" }}
                >
                  <span
                    className="currently"
                    style={{ color: !confirmWorkEligiblility ? "#fa4a4a" : "" }}
                  >
                    I am eligible to work or possess the relevant immigration
                    status to work in the UK on a self-employed basis. Learn
                    more about
                    <br />
                    <span
                      className="theme"
                      onClick={() => props.history.push("/Uk-Self-EmpLaw")}
                      style={{
                        color: !confirmWorkEligiblility ? "#fa4a4a" : "",
                        fontWeight: !confirmWorkEligiblility ? "bold" : "",
                        textDecoration: !confirmWorkEligiblility
                          ? "underline"
                          : "",
                      }}
                    >
                      UK self-employment law.
                    </span>
                  </span>
                  <input
                    type="checkbox"
                    id="customCheck91"
                    defaultChecked={confirmWorkEligiblility}
                    onClick={
                      !iscompletedForm
                        ? () =>
                            updateState({
                              ...state,
                              confirmWorkEligiblility: !state.confirmWorkEligiblility,
                            })
                        : () => {}
                    }
                  />
                  <span
                    className="checkmark"
                    style={{
                      borderColor: !confirmWorkEligiblility ? "#fa4a4a" : "",
                      backgroundColor: !confirmWorkEligiblility
                        ? "#fff1f1"
                        : "",
                    }}
                  ></span>
                </label>
              </div>
              <div className="checkBoxContainer">
                <label
                  className="container"
                  htmlFor="customCheck92"
                  style={{ paddingTop: "13px" }}
                >
                  <span
                    className="currently"
                    style={{ color: !confirmValidDocs ? "#fa4a4a" : "" }}
                  >
                    I confirm that my descriptions and documents supplied are my
                    own, and accurately reflect my tutoring sessions.
                  </span>
                  <input
                    type="checkbox"
                    id="customCheck92"
                    defaultChecked={confirmValidDocs}
                    onClick={
                      !iscompletedForm
                        ? () =>
                            updateState({
                              ...state,
                              confirmValidDocs: !state.confirmValidDocs,
                            })
                        : () => {}
                    }
                  />
                  <span
                    className="checkmark"
                    style={{
                      borderColor: !confirmValidDocs ? "#fa4a4a" : "",
                      backgroundColor: !confirmValidDocs ? "#fff1f1" : "",
                    }}
                  ></span>
                </label>
              </div>
              <div className="checkBoxContainer">
                <label
                  className="container"
                  htmlFor="customCheck93"
                  style={{ paddingTop: "13px" }}
                >
                  <span
                    className="currently"
                    style={{ color: !agreeToTOS ? "#fa4a4a" : "" }}
                  >
                    {`I agree to the `}
                    <span
                      className="theme"
                      onClick={() =>
                        props.history.push("/Service-and-refundPolicy")
                      }
                      style={{
                        color: !agreeToTOS ? "#fa4a4a" : "",
                        fontWeight: !agreeToTOS ? "bold" : "",
                        textDecoration: !agreeToTOS ? "underline" : "",
                      }}
                    >
                      Askademia Tutoring Terms and Service and Refund Policy.
                    </span>
                  </span>
                  <input
                    type="checkbox"
                    id="customCheck93"
                    defaultChecked={agreeToTOS}
                    onClick={
                      !iscompletedForm
                        ? () =>
                            updateState({
                              ...state,
                              agreeToTOS: !state.agreeToTOS,
                            })
                        : () => {}
                    }
                  />
                  <span
                    className="checkmark"
                    style={{
                      borderColor: !agreeToTOS ? "#fa4a4a" : "",
                      backgroundColor: !agreeToTOS ? "#fff1f1" : "",
                    }}
                  ></span>
                </label>
              </div>

              <p className="step-title" style={{ marginTop: "26px" }}>
                Add your mobile number
              </p>
              <p className="step-subtitle">
                We’ll send you updates about session requests, upcoming sessions
                and other notifications. This number should be a UK number and
                should be able to receive texts or calls.
              </p>
              <div className="row">
                <div className="col-lg-10 col-md-9">
                  <div
                    tabIndex="-1"
                    className="comp_input"
                    onBlur={(e) =>
                      updateState({ ...state, onFocusPhoneNumber: false })
                    }
                    onFocus={(e) =>
                      updateState({ ...state, onFocusPhoneNumber: true })
                    }
                    style={{
                      color: color,
                      borderColor: borderColor,
                      backgroundColor: backgroundColor,
                    }}
                  >
                    <span
                      id="basic-addon1"
                      className="mobile"
                      onBlur={(e) =>
                        updateState({ ...state, onFocusPhoneNumber: false })
                      }
                      onFocus={(e) =>
                        updateState({ ...state, onFocusPhoneNumber: true })
                      }
                      style={{
                        color: onFocusPhoneNumber ? "#2cb46d" : color,
                        borderColor: borderColor,
                        backgroundColor: backgroundColor,
                      }}
                    >
                      +44
                    </span>
                    <input
                      type="number"
                      value={phoneNumber}
                      aria-label="Username"
                      className="form-control"
                      aria-describedby="basic-addon1"
                      disabled={!iscompletedForm ? false : true}
                      onBlur={(e) =>
                        updateState({ ...state, onFocusPhoneNumber: false })
                      }
                      onFocus={(e) =>
                        updateState({ ...state, onFocusPhoneNumber: true })
                      }
                      style={{
                        color: color,
                        borderColor: borderColor,
                        backgroundColor: backgroundColor,
                      }}
                      onChange={(e) =>
                        updateState({
                          ...state,
                          phoneNumber: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="error">
                    {!phoneNumber
                      ? validationError?.data?.phoneNumber
                        ? warningError
                        : ""
                      : ""}
                    {!phoneNumber
                      ? validationError?.data?.phoneNumber
                        ? "Please enter a valid phone number"
                        : ""
                      : ""}
                  </div>
                </div>
                <div className="col-lg-2 col-md-3">
                  <button className="btn">Verify</button>
                </div>
              </div>
              <p className="submitSmall">
                <i className="mdi mdi-lock mr-1"></i>This information is not
                shared with other users of Askademia
              </p>
              <p className="step-title">Enter your security code</p>
              <p className="step-subtitle m-0">
                We texted your code to +44 {phoneNumber}. It may take a minute to
                arrive. You entered security code {securityCode}{" "}
              </p>
              <div className="securityCode">
                <input
                  id="num1"
                  name="num1"
                  value={num1}
                  type="number"
                  autoFocus={false}
                  placeholder="&#x2015;"
                  ref={(c) => (num1Input = c)}
                  onFocus={(e) => handleFocus(e)}
                  onKeyDown={(e) => handleKey(e, 1)}
                  onChange={(e) => handleChange(e, 1)}
                  className={ validationError?.data ? "error" : "" }
                />
                <input
                  id="num2"
                  name="num2"
                  value={num2}
                  type="number"
                  placeholder="&#x2015;"
                  ref={(c) => (num2Input = c)}
                  onFocus={(e) => handleFocus(e)}
                  onKeyDown={(e) => handleKey(e, 2)}
                  onChange={(e) => handleChange(e, 2)}
                  className={ validationError?.data ? "error" : "" }
                />
                <input
                  id="num3"
                  name="num3"
                  value={num3}
                  type="number"
                  placeholder="&#x2015;"
                  ref={(c) => (num3Input = c)}
                  onFocus={(e) => handleFocus(e)}
                  onKeyDown={(e) => handleKey(e, 3)}
                  onChange={(e) => handleChange(e, 3)}
                  className={ validationError?.data ? "error" : "" }
                />
                <input
                  id="num4"
                  name="num4"
                  value={num4}
                  type="number"
                  placeholder="&#x2015;"
                  ref={(c) => (num4Input = c)}
                  onFocus={(e) => handleFocus(e)}
                  onKeyDown={(e) => handleKey(e, 4)}
                  onChange={(e) => handleChange(e, 4)}
                  className={ validationError?.data ? "error" : "" }
                />
              </div>
              <div className="error">
                { validationError?.data ? warningError : "" }
                { validationError?.data ? "We are unable to validate your phone number. Please try again." : "" }
              </div>
              <p className="step-subtitle" style={{ marginTop: "13px" }}>
                Didn't receive it?{" "}
                <span style={{ color: "#2cb46d" }}>Resend</span>
              </p>
            </Col>
          </Row>
          <Nextsteps step={9} {...props} submitStepInRedux={submitStep9Info} />
        </div>
      </Col>
    </Row>
  );
};
